import { render, staticRenderFns } from "./CollapseComponent.vue?vue&type=template&id=19c5edfd&scoped=true&lang=pug"
import script from "./CollapseComponent.vue?vue&type=script&lang=js"
export * from "./CollapseComponent.vue?vue&type=script&lang=js"
import style0 from "./CollapseComponent.vue?vue&type=style&index=0&id=19c5edfd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19c5edfd",
  null
  
)

export default component.exports